import base from './base'

let controller = 'supervisor'
let action = null

const Supervisor = {
  async listSupervisors (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    querys.isLocal = query.isLocal !== null ? query.isLocal ? true : false : null
    action = 'ListSupervisors'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async getMySupervisorDetail () {
    action = `MyDetail`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getSupervisorDetail (supervisorId) {
    if (!supervisorId) {
      throw new Error('SupervisorId为空')
    }
    action = `Detail/${supervisorId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getSupervisorPermissions (supervisorId, cityId = 0, industryId = 0) {
    if (!supervisorId) {
      throw new Error('SupervisorId为空')
    }
    action = `GetSupervisionPermissions/${supervisorId}/${cityId}/${industryId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getMySupervisorPermissions (cityId = 0, industryId = 0) {
    action = `GetMySupervisionPermissions/${cityId}/${industryId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async addSupervisor (request) {
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async updateSupervisor (request) {
    if (!request.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${request.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async editSupervisorRegion (req) {
    if (!req.supervisorId) {
      throw new Error('SupervisorId为空')
    }
    action = `EditRegionPermission`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        supervisorId: parseInt(req.supervisorId),
        regionId: 0,
        canPreauditGuarantor: req.canPreauditGuarantor,
        canAuditGuarantor: req.canAuditGuarantor,
        canBlacklistGuarantor: req.canBlacklistGuarantor,
        canClaim: req.canClaim,
        canAddProjectRegister: req.canAddProjectRegister,
        canAuditProjectRegister: req.canAuditProjectRegister,
        projectRegisterMode: req.projectRegisterMode
      }
    }
    return base.request(reqModel)
  },

  async deleteSupervisor (supervisorId) {
    if (!supervisorId) {
      throw new Error('SupervisorId为空')
    }
    action = `Delete/${supervisorId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async addUesrToSupervisor (supervisorId, userId, isAdmin = true) {
    if (!supervisorId || !userId) {
      throw new Error('SupervisorId或UserId为空')
    }
    action = `AddUser/${supervisorId}/${userId}/${isAdmin}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async removeUesrFromSupervisor (supervisorId, userId) {
    if (!supervisorId || !userId) {
      throw new Error('SupervisorId或UserId为空')
    }
    action = `RemoveUser/${supervisorId}/${userId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async removeUesrFromSupervisorById (tid) {
    if (!tid) {
      throw new Error('tid为空')
    }
    action = `RemoveUser/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async addSupervisorToIndustry (req) {
    if (!req.supervisorId || !req.industryId) {
      throw new Error('SupervisorId或IndustryId为空')
    }
    action = `AddIndustry`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        supervisorId: req.supervisorId,
        industryId: req.industryId,
        readOnly: req.readOnly || false,
        canAudit: req.canAudit || false,
        canPreAudit: req.canPreAudit || false,
        canAuditTerminate: req.canAuditTerminate || false,
        canAuditRenewal: req.canAuditRenewal || false,
        canClaim: req.canClaim || false,
        canAddProjectRegister: req.canAddProjectRegister || false,
        canAuditProjectRegister: req.canAuditProjectRegister || false
      }
    }
    return base.request(reqModel)
  },

  async editSupervisorIndustry (req) {
    if (!req.supervisorId || !req.industryId) {
      throw new Error('SupervisorId或IndustryId为空')
    }
    action = `EditIndustry`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        supervisorId: req.supervisorId,
        industryId: req.industryId,
        readOnly: req.readOnly,
        canAudit: req.canAudit,
        canPreAudit: req.canPreAudit,
        canAuditTerminate: req.canAuditTerminate,
        canAuditRenewal: req.canAuditRenewal,
        canClaim: req.canClaim,
        canAddProjectRegister: req.canAddProjectRegister,
        canAuditProjectRegister: req.canAuditProjectRegister
      }
    }
    return base.request(reqModel)
  },

  async removeSupervisorFromIndustry (supervisorId, industryId) {
    if (!supervisorId || !industryId) {
      throw new Error('SupervisorId或IndustryId为空')
    }
    action = `RemoveIndustry/${supervisorId}/${industryId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async removeSupervisorFromIndustryById (tid) {
    if (!tid) {
      throw new Error('tid为空')
    }
    action = `RemoveIndustry/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async addSupervisorToCity (req) {
    if (!req.supervisorId || !req.cityId) {
      throw new Error('SupervisorId或CityId为空')
    }
    action = `AddCity`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        supervisorId: req.supervisorId,
        cityId: req.cityId,
        readOnly: req.readOnly || false,
        canAudit: req.canAudit || false,
        canPreAudit: req.canPreAudit || false,
        canAuditTerminate: req.canAuditTerminate || false,
        canAuditRenewal: req.canAuditRenewal || false,
        canClaim: req.canClaim || false,
        canAddProjectRegister: req.canAddProjectRegister || false,
        canAuditProjectRegister: req.canAuditProjectRegister || false
      }
    }
    return base.request(reqModel)
  },

  async editSupervisorCity (req) {
    if (!req.supervisorId || !req.cityId) {
      throw new Error('SupervisorId或CityId为空')
    }
    action = `EditCity`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        supervisorId: req.supervisorId,
        cityId: req.cityId,
        readOnly: req.readOnly,
        canAudit: req.canAudit,
        canPreAudit: req.canPreAudit,
        canAuditTerminate: req.canAuditTerminate,
        canAuditRenewal: req.canAuditRenewal,
        canClaim: req.canClaim,
        canAddProjectRegister: req.canAddProjectRegister,
        canAuditProjectRegister: req.canAuditProjectRegister
      }
    }
    return base.request(reqModel)
  },

  async removeSupervisorFromCity (supervisorId, cityId) {
    if (!supervisorId || !cityId) {
      throw new Error('SupervisorId或CityId为空')
    }
    action = `RemoveCity/${supervisorId}/${cityId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async removeSupervisorFromCityById (tid) {
    if (!tid) {
      throw new Error('tid为空')
    }
    action = `RemoveCity/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }
}

export default Supervisor